// DS: MO 0.9
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import SuspenseWithServerFallback from '../../../SuspenseWithServerFallback';
import ModuleLoaderLazy from '../../redux/ModuleLoaderLazy';
import { RequestStatus } from '../../redux/types';
import FallbackErrorBoundary from '../../FallbackErrorBoundary';
import { useEstimatedEarningsDisplay } from '../../hooks';
import { updatePrice } from '../../redux/actions';
import EarningsDisplay from '../../lego/EarningsDisplay';
import ErrorPostfix from '../../lego/ErrorPostfix';
import LoadingPostfix from '../../lego/LoadingPostfix';
import InfoPostfix from '../../lego/InfoPostfix';
/**
 * Displays estimated earnings given a {@link Props.price|price} and a {@link Props.productType|productType}.
 *
 * This comes with its own redux to fetch the estimated earnings from our backend. You can just plop it into
 * your component.
 */ const EarningsCalculator = ({ price, productType, isResale, className })=>{
    const dispatch = useDispatch();
    const { displayId, earnings: estimatedEarnings, serviceFeePercent, requestInfo } = useEstimatedEarningsDisplay(price, productType, isResale);
    const handleRetryBackendRequest = useCallback(()=>{
        dispatch(updatePrice(displayId, price));
    }, [
        dispatch,
        displayId,
        price
    ]);
    return(// Error boundary for the dynamic redux module
    /*#__PURE__*/ React.createElement(FallbackErrorBoundary, {
        fallback: (_error, clearError)=>/*#__PURE__*/ React.createElement(EarningsDisplay, {
                className: className,
                earnings: 0.0,
                // clearing the error should make our redux module retry automatically
                postfix: /*#__PURE__*/ React.createElement(ErrorPostfix, {
                    onRetry: clearError
                })
            })
    }, /*#__PURE__*/ React.createElement(SuspenseWithServerFallback, {
        fallback: /*#__PURE__*/ React.createElement(EarningsDisplay, {
            className: className,
            earnings: estimatedEarnings,
            postfix: /*#__PURE__*/ React.createElement(LoadingPostfix, null)
        })
    }, /*#__PURE__*/ React.createElement(ModuleLoaderLazy, null), /*#__PURE__*/ React.createElement(EarningsDisplay, {
        className: className,
        earnings: estimatedEarnings,
        postfix: /*#__PURE__*/ React.createElement(React.Fragment, null, requestInfo.status === RequestStatus.Error && /*#__PURE__*/ React.createElement(ErrorPostfix, {
            onRetry: handleRetryBackendRequest
        }), requestInfo.status === RequestStatus.Fetching && /*#__PURE__*/ React.createElement(LoadingPostfix, null), // Assuming the backend request succeeded, we should have the service fee percent. Gotta
        // check in this conditional to appease typescript though.
        requestInfo.status === RequestStatus.Idle && serviceFeePercent !== null && serviceFeePercent !== undefined && /*#__PURE__*/ React.createElement(InfoPostfix, {
            serviceFeePercent: serviceFeePercent,
            isResale: isResale
        }))
    }))));
};
EarningsCalculator.displayName = 'EarningsCalculator';
export default EarningsCalculator;
